
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { Ordine, Lavorazione, StatoLavorazione, VariazioneLavorazione, Azione, ProgressoLavorazione, Utente } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import { LoadingTemplateType } from './enums/LoadingTemplateType';

@Component({
  components: {
    GruppoLavorazionePerStagioneTabella: () => import('@/components/GruppoLavorazionePerStagioneTabella.vue'),
    GruppoLavorazionePerFaseTabella: () => import('@/components/GruppoLavorazionePerFaseTabella.vue'),
    GruppoLavorazionePerConsegnaTabella: () => import('@/components/GruppoLavorazionePerConsegnaTabella.vue'),
    GruppoLavorazionePerLottoTabella: () => import('@/components/GruppoLavorazionePerLottoTabella.vue')
  }
})
export default class Statistiche extends Vue {
    get loading () {
        return store.state.loading;
    }
    get user() { return store.state.currentUsr; }
    get userIsAdmin() {
      return (
        this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined
      );
    }

    private templates = LoadingTemplateType;

    get fornitori(): Utente[] {
      return store.state.fornitori;
    }

  get fornitore(): Utente | undefined {
    return store.state.fornitore;
  }

  get loadTemplateCorrente() : LoadingTemplateType {
    return LoadingTemplateType.Card;
  }
  public idFornitore: string = '';

  set fornitore(fornitore: Utente | undefined) {
    store.commit(StoreMutations.SetFornitore, fornitore);
    if (fornitore) {
      this.idFornitore = fornitore.id;
    } else {
      this.idFornitore = '';
    }
  }

  created(): void {
    if (this.userIsAdmin) {
      this.fornitore = undefined;
      store.dispatch(StoreActions.GetFornitori);
    } else {
      this.idFornitore = this.user.idFornitore;
    }
  }
}
